import {ParameterDto} from "../api/services/parameters";

export const extractParam = (parameters: ParameterDto[], paramType: number) => parameters?.filter(k => k.parameterType == paramType).map(l => ({
    id: l.id ?? "",
    name: l.parameterValue ?? ""
})) ?? []

export const extractParamByCode = (parameters: ParameterDto[], paramType: number, paramCode: string) => 
    parameters?.filter(k => k.parameterType == paramType && k.parameterCode == paramCode).map(l => ({
    id: l.id ?? "",
    name: l.parameterValue ?? ""
})) ?? []